<div id="backdrop" class="modal-backdrop" [ngClass]="{ show: showModal }"></div>
<div class="modal d-block fade" 
  [ngClass]="{ show: showModal }"
  id="listing-dialog" 
  tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog mw-100 w-75" role="document" (click)="onDialogClick($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="showModal"><strong>Analysekategorie:</strong> {{customerObject?.name}}</h5>
                <button type="button"
                    class="close"
                    (click)="goBack()"
                    aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
           
             

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="delete()">löschen</button>
              <button type="button" class="btn btn-primary" (click)="goBack()">schließen</button>
            </div>
        </div>
    </div>
</div>
